import { PageHeader } from '@/components/shared/page-header';
import { PricingSkeleton } from '@/components/shared/skeleton';

export function Loading() {
  return (
    <>
      <PageHeader
        title="Pricing management"
        description="Configure charging rates and fees for companies and stations"
      />
      <PricingSkeleton />
    </>
  );
}
